<template>
    <form-row title="Has the inspection reports been received?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="has_received_inspection_reports"
                v-model="has_received_inspection_reports"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="has_received_inspection_reports"
                class="mt-4 sm:ml-12 sm:-mt-2 sm:-mb-2 flex flex-1 items-center sm:justify-end"
                label="Date Received:"
                :value="attorney.received_inspection_reports_at"
                name="received_inspection_reports_at"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        attorney: {},
        read_only: { default: false },
    },

    data() {
        return {
            has_received_inspection_reports: this.attorney.has_received_inspection_reports,
        }
    },
}
</script>
